module.exports = __webpack_public_path__ + "img/download-icon.23bcf1f4.svg";